<mat-drawer-container class="main-container" style="background-color: white;" autosize>
    <mat-drawer #drawer class="sidenav-drawer" class="drawer-style" mode="side" opened>
        <div class="mt-40">
        </div>
    </mat-drawer>
    <mat-drawer-content class="">
        <div class="sidenav-content">
            <div class="row mt-2 ml-5 pr-5 firstrow justify-content-end">               
                <button mat-stroked-button color="primary" class="button-drawer" (click)="navigateLogIn()"> 
                    Sign in</button>
            </div>
            <div class="row col-12 m-0 pt-5 centerAlign">
                <div class="col-4 mt-2 fontsize">
                    <div class="row mt-3  pl-4">
                        <span class="sub-title">Create and manage health care assessments/surveys</span>
                    </div>
                    <div class="row mt-3 pl-4">
                        <span class="sub-title">Create and manage business process with workflows</span>
                    </div>
                    <div class="row mt-3  pl-4">
                        <span class="sub-title">Rich library of health care templates</span>
                    </div>
                    <div class="row mt-3  pl-4">
                        <span class="sub-title">HIPAA and ADA compliant</span>
                    </div>
                    <div class="row mt-3  pl-4">
                        <span class="sub-title">Analytics and reporting</span>
                    </div>
                    <div class="row mt-3  pl-4">
                        <span class="sub-title">API integration</span>
                    </div>
                    <!-- <div class="row mt-3  pl-4">
                        <button mat-stroked-button color="primary" class="button-drawer"> + Learn More</button>
                    </div>                     -->
                </div>
                <div class="col-4  mt-3" >
                    <!-- <img class="ml-4 imgStyle" src="/assets/images/SI4.png" alt="HS logo"> -->
                    <img src="/assets/images/image.png" alt="" class="imgstyle ml-3">
                </div>
                
            </div>
        </div>
    </mat-drawer-content>

    <mat-drawer-content>
        <router-outlet></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>